import { type FC } from 'react'
import { useTheme } from '@mui/material/styles'

import LinkButton from '@DS/components/forms/links/linkButton/LinkButton'

import * as styles from './styles'

export type ActionProps = {
  label: string
  onClick: VoidFunction
}

type TooltipActionsProps = {
  actions: ActionProps[]
}

const TooltipActions: FC<TooltipActionsProps> = ({ actions }) => {
  const theme = useTheme()

  return (
    <div css={styles.tooltipActions(theme)}>
      {actions.map(({ label, onClick }) => (
        <LinkButton key={label} onClick={onClick} css={styles.tooltipActionsButton(theme)}>
          {label}
        </LinkButton>
      ))}
    </div>
  )
}

export default TooltipActions
